import { render, staticRenderFns } from "./footers.vue?vue&type=template&id=364df325&scoped=true&"
import script from "./footers.vue?vue&type=script&lang=js&"
export * from "./footers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364df325",
  null
  
)

export default component.exports